import { Account } from '../../Model/Account';
import { AccountRepository, CreateAccountDTO } from '../Repositories/AccountRepository';
import { mapCreateOrUpdateAccountError } from './AccountErrors';
import { ok, err, Result } from 'neverthrow';

export class CreateAccountUseCase {
  constructor(private readonly repo: AccountRepository) {}

  execute(cmd: CreateAccountDTO): Promise<Result<Account, string>> {
    return this.repo
      .createAccount(cmd)
      .then((account) => ok<Account, string>(account))
      .catch((e) => err<Account, string>(mapCreateOrUpdateAccountError(e).message));
  }
}
